import { render, staticRenderFns } from "./ActiveRegistrationDayPass.vue?vue&type=template&id=6300d203"
import script from "./ActiveRegistrationDayPass.vue?vue&type=script&lang=js"
export * from "./ActiveRegistrationDayPass.vue?vue&type=script&lang=js"
import style0 from "./ActiveRegistrationDayPass.vue?vue&type=style&index=0&id=6300d203&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports